<template>
  <div>
    <Head title="Головна"></Head>
    <h1 class="mb-8 text-3xl font-bold">Головна</h1>
    <p class="leading-normal">Ласкаво просимо до адмінистративної панелі сайту «Хвиля».</p>
    <p class="mb-8 leading-normal">Скористуйтеся панелю навігації зліва щоб додати озера, місця рибалки, тарифи, типи рибалки, а також подивитися створені замовлення.</p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout.vue'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script>
